import { ChevronDown } from 'lucide-react';
import {
  Button,
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@design-system';
import type { CareScenarioSummary, ConsumerQuote, ConsumerQuoteProjection } from '@shared/consumerPlan';
import { CareCostBreakdown } from './care-cost-breakdown';
import { PolicyTermsList } from './policy-terms-list';

interface CoverageDetailsSectionProps {
  quote: ConsumerQuote;
  projection: ConsumerQuoteProjection | undefined;
  scenario: CareScenarioSummary;
}

export function CoverageDetailsSection({ quote, projection, scenario }: CoverageDetailsSectionProps) {
  return (
    <Collapsible defaultOpen className="group/details rounded-lg border bg-white">
      <CollapsibleTrigger asChild>
        <Button variant="ghost" className="w-full justify-between pb-3">
          Policy details and cost breakdown
          <ChevronDown className="transition-transform duration-200 ease-out group-data-[state=open]/details:rotate-180" />
        </Button>
      </CollapsibleTrigger>
      <CollapsibleContent className="flex flex-col gap-4 px-4 pt-1 pb-4">
        <Tabs defaultValue="policy-details">
          <TabsList aria-label="Coverage details" className="w-full">
            <TabsTrigger value="policy-details">Policy details</TabsTrigger>
            <TabsTrigger value="cost-breakdown">Cost breakdown</TabsTrigger>
          </TabsList>
          <TabsContent value="policy-details" className="flex flex-col gap-3">
            <PolicyTermsList
              quote={quote}
              projection={projection}
              careStartAge={scenario.careStartAge}
              yearsUntilCare={scenario.yearsUntilCare}
            />
            <p className="text-muted-foreground text-sm">
              Reimbursement is limited by covered expenses. Cash benefits follow eligibility and contract limits.
            </p>
          </TabsContent>
          <TabsContent value="cost-breakdown">
            <CareCostBreakdown scenario={scenario} />
          </TabsContent>
        </Tabs>
      </CollapsibleContent>
    </Collapsible>
  );
}
